/** Update Plan state */ export var PlanMoveOperationStatus = /*#__PURE__*/ function(PlanMoveOperationStatus) {
    /** Move Plan is in progress. */ PlanMoveOperationStatus["InProgress"] = "InProgress";
    /** Move Plan is completed. */ PlanMoveOperationStatus["Completed"] = "Completed";
    /** Move Plan has completed with errors. */ PlanMoveOperationStatus["CompletedWithErrors"] = "CompletedWithErrors";
    return PlanMoveOperationStatus;
}({});
